// extracted by mini-css-extract-plugin
export default {"root":"XGrid_root__CO74N"};